// extracted by mini-css-extract-plugin
export var amenityLabel = "TVHMXIN_80Yet_Dq4URJ";
export var cardBody = "Lf1VhEumCDopBrdvoaJM";
export var footerContainer = "e09QjvNuAbM2WAQFFHlb";
export var hasFooter = "XlEmhKAddVwvixj2aeYm";
export var hasHeader = "ka8ZLRczfIBi56k1lZNR";
export var track = "SXBApl66L7lQxPo6zyJF";
export var transitLeg = "g6T4n5wimWbIsinaPbY4";